import { api, must } from "../api/client";
import type { Wallet } from "./wallet";

export interface FetchSummary { text: string; error?: boolean }

/**
 * Fetch the delegations issued to this wallet's DID (POST /dids/{did}/delegations,
 * signed by this browser) and keep the active ones: after a restore or a link they
 * appear without the offer link. Returns a sentence for /me.
 */
export async function fetchMyDelegations(wallet: Wallet): Promise<FetchSummary> {
  const rec = wallet.record;
  if (!rec || rec.method !== "webvh") return { text: "" };
  try {
    const jws = await wallet.delegationsFetchJws();
    const res = await must(api.POST("/dids/{did}/delegations", { params: { path: { did: rec.did } }, body: { jws } }));
    const r = await wallet.importDelegations(res.delegations as any);
    const active = res.delegations.length - r.revoked - r.refused;
    const revokedNote = r.revoked ? ` (${r.revoked} revoked, not added)` : "";
    const text = !res.delegations.length ? "No delegation has been issued to your DID."
      : active === 0 ? `Found no active delegation issued to your DID${revokedNote}.`
      : `Found ${active} delegation${active === 1 ? "" : "s"} issued to your DID${revokedNote}.`;
    return { text };
  } catch (e) {
    return { text: `Could not fetch your delegations: ${(e as Error).message}`, error: true };
  }
}
